import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { CheckboxCard } from "../../../../../../../shared/components/checkbox/CheckboxCard"

const useStyles = makeStyles()((theme) => ({
    label: {
        fontWeight: 700,
    },
    sublabel: {
        color: theme.palette.tailwind.gray[400],
    },
}))

type Props = Readonly<{
    checked: boolean
    onChange: (checked: boolean) => void
}>

/** The overwrite choice of the week menu copy dialogs. */
export function WeekMenuOverwriteCheckbox({ checked, onChange }: Props) {
    const { classes } = useStyles()

    return (
        <CheckboxCard
            checked={checked}
            onChange={onChange}
            label={
                <LocalizedStrict id="merchant-week-menu-copy-overwrite-label">
                    <Typography variant="body2" className={classes.label}>
                        Overwrite filled dishes
                    </Typography>
                </LocalizedStrict>
            }
            sublabel={
                <LocalizedStrict
                    id={
                        checked
                            ? "merchant-week-menu-copy-overwrite-sublabel-on"
                            : "merchant-week-menu-copy-overwrite-sublabel"
                    }
                >
                    <Typography variant="caption" className={classes.sublabel}>
                        {checked
                            ? "On — existing dishes will be overwritten too."
                            : "Off — only empty slots are filled, existing dishes are kept."}
                    </Typography>
                </LocalizedStrict>
            }
        />
    )
}
